<template>
  <!-- 导出只包含国家、省、校级资源库,不含精品课省级报告 -->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" id="pdfPrint" ref="pdfContent">
      <!-- PDF  首页 -->
      <div
        class="page-box">
        <!-- 正文 -->
        <div id="PdfTitle">
          <h1 v-if="userType === '学生'" style="text-align: center;font-size: 60px">
            “{{ header.userName }}”学生学习分析报告
          </h1>
          <h1  style="text-align: center;font-size: 60px" v-else>“{{ header.userName }}”教师应用分析报告</h1>
          <div class="number_time">
            <div>
              <span
              >所属资源库：{{ header.zykName }}（{{ header.zykNum }}）</span
              >
              <span>截止时间：{{ header.monitorDate }}</span>
            </div>
            <p></p>
            <p></p>
          </div>
        </div>
        <div class="chart_box">
          <p>
            “{{ header.userName }}”是来自{{ header.schoolName }}的一名{{
            header.role
            }}，自{{ header.createTime }}使用“{{
            header.zykName
            }}”专业教学资源库，有使用行为发生的天数为{{
            header.actionDays
            }}天，累计产生行为记录{{ header.userActionCount }}条。该{{
            header.role
            }}网上行为分布情况如图1所示：
          </p>
          <div class="standards_content echartsHeight">
            <discountChart
              :refId="'userBehaviorChart'"
              :datas="userBehavior.dataList"
              :transverseData="userBehavior.transverseData"
              :colorList="userBehavior.colorList"
              :legendList="userBehavior.legendList"
              :innerText="'单位：次'"
              :isShowTextColor="true"
              :is-export-text-color="true"
            ></discountChart>
          </div>
          <div class="chart_name">图1 网上行为分布情况</div>
          <div v-if="userType === '教师'">
            <p class="m-top150">
              该{{ header.role }}自加入本资源库建设以来上传资源总数为{{
              teacherUploaded.total
              }}条，其上传资源类型数量及占比如图2所示：
            </p>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'teacherUploadedChart'"
                :datas="teacherUploaded.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
                :legendListFontSize="30"
              ></circularChart>
            </div>
            <div class="chart_name">图2 上传资源类型分布</div>
            <p class="m-top150">
              该{{ header.role }}自加入本资源库建设以来所创建的课程共{{
              createdTeacher.total
              }}门，按访问量排名<span v-if="createdTeacher.dataList.length === 10"
            >前10名</span
            ><span v-else>前列</span>的课程如图3所示：
            </p>
            <div class="biaoge">
              <table
                border="1"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <td>序号</td>
                  <td>课程名称</td>
                  <td>课程类型</td>
                  <td>选课人数</td>
                  <td>创建时间</td>
                </tr>
                <tr
                  v-for="(item, index) in createdTeacher.dataList"
                  :key="index"
                  v-show="createdTeacher.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.courseName }}</td>
                  <td>{{ item.courseType }}</td>
                  <td>{{ parseInt(item.num) }}</td>
                  <td>
                    {{
                    item.createdTime ? item.createdTime.substring(0, 10) : ""
                    }}
                  </td>
                </tr>
                <tr v-show="createdTeacher.dataList.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">图3 该教师所创建的课程访问量排名</div>
        </div>
          <div v-if="userType === '学生'">
            <p class="m-top150">
              该{{ header.role }}使用资源库运行平台主要开展了
              {{ header.carryOutAction }} 等活动，各模块使用情况如图2所示：
            </p>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'platformChart'"
                :datas="platform.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :showValue="true"
                :legendLeft="'60%'"
                :circleSize="80"
                :legendListFontSize="30"
              ></circularChart>
            </div>
            <div class="chart_name">图2 平台各模块使用情况</div>
            <p class="m-top150">
              该{{
              header.role
              }}近一年在课程、资源、作业、论坛模块使用情况如图3所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'assignmentsChart'"
                :datas="assignments.dataList"
                :transverseData="assignments.transverseData"
                :colorList="assignments.colorList"
                :legendList="assignments.legendList"
                :innerText="'单位：次'"
                :isShowTextColor="true"
                :is-export-text-color="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图3 近一年课程、资源、作业、论坛访问使用情况
            </div>
          </div>
      </div>
      </div>

      <!-- 第三页 -->
      <div class="chart_box page-box">
        <div v-if="userType === '教师'">
          <p class="m-top100">
            该{{ header.role }}使用资源库运行平台主要开展了
            {{ header.carryOutAction }} 等活动，各模块使用情况如图4所示：
          </p>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'platformChart'"
              :datas="platform.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :showValue="true"
              :legendLeft="'60%'"
              :circleSize="80"
              :legendListFontSize="30"
            ></circularChart>
          </div>
          <div class="chart_name">图4 平台各模块使用情况</div>
          <p class="m-top150">
            该{{
            header.role
            }}近一年在课程、资源、作业、论坛模块使用情况如图5所示：
          </p>
          <div class="standards_content echartsHeight">
            <discountChart
              :refId="'assignmentsChart'"
              :datas="assignments.dataList"
              :transverseData="assignments.transverseData"
              :colorList="assignments.colorList"
              :legendList="assignments.legendList"
              :innerText="'单位：次'"
              :isShowTextColor="true"
              :is-export-text-color="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图5 近一年课程、资源、作业、论坛访问使用情况
          </div>
        </div>
        <p class="m-top100">
          该{{ header.role }}近一年访问时间段分布如图<span
          v-if="userType === '学生'"
        >4</span
        ><span v-else>6</span>所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'timePeriodChart'"
            :datas="timePeriod.dataList"
            :transverseData="timePeriod.transverseData"
            :colorList="timePeriod.colorList"
            :legendList="timePeriod.legendList"
            :innerText="'单位：次'"
            :isShowTextColor="true"
            :is-export-text-color="true"
          ></discountChart>
        </div>
        <div class="chart_name">
          图<span v-if="userType === '学生'">4</span
        ><span v-else>6</span> 近一年访问时间段分布情况
        </div>
        <div class="m-top150" v-if="userType === '学生'">
          <p>
            该{{ header.role }}共参与了{{
            studentStudy.total
            }}门课程的学习，按访问课程次数排名<span
            v-if="studentStudy.dataList.length === 15"
          >前15名</span
          ><span v-else>前列</span>如图5所示：
          </p>
          <div class="biaoge">
            <table
              border="1"
              cellpadding="0"
              cellspacing="0"
              width="100%"
              bordercolor="#fff"
              class="course"
            >
              <tr>
                <td>序号</td>
                <td>课程名称</td>
                <td>课程类型</td>
                <td>学习起始时间</td>
                <td>访问课程次数</td>
              </tr>
              <tr
                v-for="(item, index) in studentStudy.dataList"
                :key="index"
                v-show="studentStudy.dataList.length != 0"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.courseName }}</td>
                <td>{{ item.courseType }}</td>
                <td>
                  {{
                  item.createdTime ? item.createdTime.substring(0, 10) : ""
                  }}
                </td>
                <td>{{ item.logNum }}</td>
              </tr>
              <tr v-show="studentStudy.dataList.length == 0" class="nothing">
                <td colspan="5">无</td>
              </tr>
            </table>
          </div>
          <div class="chart_name">图5 学习课程情况列表</div>
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
  import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
  import discountChart from "@/components/chart/discountChart.vue"; // 引入折现图图表
  import pageToPDF from "@/utils/htmlToPdf.js";
  export default {
    components: {
      circularChart,
      discountChart,
    },
    data() {
      return {
        colorList: [
          "#3B85FB",
          "#FD398E",
          "#8B68F1",
          "#EE6F5E",
          "#E0D35F",
          "#5470C6",
          "#DE7E4B",
          "#DE524B",
        ], // 柱状图或折线图的颜色

        userId: "",
        userType: "",
        header: {
          userName: "",
          zykName: "",
          zykNum: "",
          schoolName: "",
          role: "",
          createTime: "",
          actionDays: "",
          userActionCount: "",
          carryOutAction: "",
          monitorDate: "",
        },
        userBehavior: {
          // 用户行为情况
          dataList: [],
          transverseData: [],
          colorList: [],
          legendList: [],
        },
        teacherUploaded: {
          // 图 2 上传资源类型分布
          total: 0,
          dataList: [],
        },
        createdTeacher: {
          // 图 3 该教师所创建的课程
          dataList: [],
          total: 0,
        },
        platform: {
          // 图 2或4 平台各模块使用情况
          dataList: [],
        },
        assignments: {
          // 图 3或5 近一年课程、资源、作业、论坛访问使用情况
          dataList: [],
          transverseData: [],
          colorList: [],
          legendList: [],
        },

        timePeriod: {
          // 图 4 近一年访问时间段分布情况,图 6 近一年访问时间段分布情况
          dataList: [],
          transverseData: [],
          colorList: [],
          legendList: [],
        },
        studentStudy: {
          // 图 5 学习课程情况列表
          dataList: [],
          total: 0,
        },
        loading: null, // 是否导出加载中
      };
    },
    mounted() {
      if (this.$route.query) {
        this.userId = decodeURIComponent(this.$route.query.userId);
        this.userType = this.$route.query.userType;
        this.header.zykName = sessionStorage.getItem("professional");
      }
      this.getStudentTeacherReportDetailDom();
      this.timePeriodDom();

      if (this.userType === "学生") {
        this.studentStudyDom();
      }
      if (this.userType === "教师") {
        this.teacherUploadedDom();
        this.createdTeacherDom();
      }
    },
    methods: {
      // echarts生成的图表转化成图片
      toImage() {
        this.loading = this.$loading({
          lock: true,
          text: "正在生成PDF中，请稍后...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$axios
          .get(
            `${this.$apiurls.exportTeaStuReport}?userId=${this.userId}&userName=${this.header.userName}&userType=${this.userType}&zykName=${this.header.zykName}`,

            {
              loading: false,
              responseType: "blob",
            }
          )
          .then((res) => {
            if (res) {
              let url = window.URL.createObjectURL(res);
              let link = document.createElement("a"); //a标签下载
              link.href = url;
              link.download = `${this.userType}_${this.header.userName}_${this.header.zykName}_${this.userType}应用分析报告.pdf`;
              link.click();
              setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              }, 0);
            }
            this.loading.close();
          })
          .catch((err) => {
            this.loading.close();
          });
      },
      // 导出pdf文件
      exportPdf() {
        const lableList = document.getElementsByClassName("page-box");
        let file_name = `${this.userType}_${this.header.userName}_${this.header.zykName}_${this.userType}应用分析报告.pdf`;
        pageToPDF(file_name, this.$refs.pdfContent, lableList);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      },
      // 图1 网上行为分布情况，图 2或4 平台各模块使用情况,图 3或5 近一年课程、资源、作业、论坛访问使用情况
      getStudentTeacherReportDetailDom() {
        this.$axios
          .post(
            this.$apiurls.applicationReport_getStudentTeacherReportDetail,
            this.userId,
            {
              loading: false,
            }
          )
          .then((res) => {
            if (res.data) {
              console.log("sdad", res);
              this.header.userName = res.data.userName;
              this.header.zykName = res.data.zykName;
              this.header.zykNum = res.data.zykNum;
              this.header.schoolName = res.data.schoolName;
              this.header.role = res.data.role;
              this.header.createTime = res.data.createTime;
              this.header.actionDays = res.data.actionDays;
              this.header.userActionCount = res.data.userActionCount;
              this.header.monitorDate = res.data.monitorDate;

              if (res.data.carryOutAction) {
                for (let i = 0; i < res.data.carryOutAction.length; i++) {
                  this.header.carryOutAction += `"${res.data.carryOutAction[i]}"，`;
                }
                this.header.carryOutAction = this.header.carryOutAction.substr(
                  0,
                  this.header.carryOutAction.length - 1
                );
              }

              this.userBehavior.dataList = res.data.userActionSituation
                ? res.data.userActionSituation.value
                : [];
              this.userBehavior.transverseData = res.data.userActionSituation
                ? res.data.userActionSituation.name
                : [];
              this.userBehavior.colorList = this.colorList;
              this.userBehavior.legendList = [];

              this.platform.dataList = res.data.eachModuleUseSituation
                ? res.data.eachModuleUseSituation
                : [];

              const valueList = [];
              if (res.data.moduleVisitSituation) {
                for (let i = 0; i < res.data.moduleVisitSituation.length; i++) {
                  valueList.push(res.data.moduleVisitSituation[i].value);
                }

                this.assignments.dataList = valueList;
                this.assignments.transverseData =
                  res.data.moduleVisitSituation[0].name;
                this.assignments.colorList = this.colorList;
                this.assignments.legendList = ["课程", "资源", "作业", "论坛"];
              }
            } else if (res.code == 404) {
              that.$message.error(res.message);
            }
          });
      },

      // 图2 上传资源类型分布
      teacherUploadedDom() {
        this.$axios
          .post(
            this.$apiurls.applicationReport_getTeacherReportUploadResource,
            this.userId,
            {
              loading: false,
            }
          )
          .then((res) => {
            if (res) {
              const arrList = [];
              this.teacherUploaded.total = 0;
              for (let i = 0; i < res.data.name.length; i++) {
                arrList.push({
                  name: res.data.name[i],
                  value: res.data.value[i],
                });
                this.teacherUploaded.total += Number(res.data.value[i]);
              }
              this.teacherUploaded.dataList = arrList;
            }
          });
      },

      // 图 3 该教师所创建的课程
      createdTeacherDom() {
        this.$axios
          .post(
            this.$apiurls.applicationReport_getUserReportCreateCourse,
            this.userId,
            {
              loading: false,
            }
          )
          .then((res) => {
            if (res) {
              let list = res.data;
              let list2 = [];
              let bool = list.every((item) => parseInt(item.num) == 0);
              if (!bool) {
                for (let i = 0; i < list.length; i++) {
                  if (parseInt(list[i].num) > 0) {
                    list2.push(list[i]);
                  }
                }
                this.createdTeacher.dataList = list2;
              } else {
                this.createdTeacher.dataList = list;
              }
              this.createdTeacher.total = this.createdTeacher.dataList.length;
              this.createdTeacher.dataList.forEach((item) => {
                if (item.courseName.length > 9) {
                  item.courseName = item.courseName.slice(0, 9) + "...";
                }
              });
              this.createdTeacher.dataList = this.createdTeacher.dataList.slice(
                0,
                10
              );
            }
          });
      },

      // 图 4 近一年访问时间段分布情况,图 6 近一年访问时间段分布情况
      timePeriodDom() {
        this.$axios
          .post(
            this.$apiurls.applicationReport_getStudentTeacherReportTimepart,
            this.userId,
            {
              loading: false,
            }
          )
          .then((res) => {
            if (res) {
              this.timePeriod.dataList = res.data.value;
              this.timePeriod.transverseData = res.data.name;
              this.timePeriod.colorList = this.colorList;
              this.timePeriod.legendList = [];
            }
          });
      },

      // 图 5 学习课程情况列表
      studentStudyDom() {
        this.$axios
          .post(
            this.$apiurls.applicationReport_getStudentReportCourseReg,
            this.userId,
            {
              loading: false,
            }
          )
          .then((res) => {
            if (res) {
              for (let i = 0; i < res.data.length; i++) {
                res.data[i].createdTime = this.renderTime(
                  res.data[i].createdTime
                );
              }
              this.studentStudy.total = res.data.length;
              this.studentStudy.dataList = res.data.splice(0, 15);
              this.studentStudy.dataList.forEach((item) => {
                for (var i = 0; i < item.logNum.length; i++) {
                  if (item.logNum[i] == ".") {
                    item.logNum = item.logNum.slice(0, i);
                  }
                }
              });
            }
          });
      },

      // 转化时间
      renderTime(date) {
        const dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      },
    },
  };
</script>
<style scoped>
  .analysisReport {
    width: 100%;
    /*height: 63020px;*/
  }

  * {
    margin: 0px;
    padding: 0px;
  }

  .analysisReport_box {
    /* width: 86.7%;
    margin: 0px auto;
    height: 73980px;*/
  }

  .header_titles {
    display: flex;
    justify-content: center;
    flex-flow: column;
    color: #000;
    text-align: center;
    position: relative;
  }

  .header_titles h1 {
    font-size: 55px;
    font-weight: bold;
    color: #1d244e;
  }

  .header_titles .monthly {
    font-size: 40px;
    font-weight: 400;
    color: #1d244e;
    line-height: 30px;
    margin-top: 6px;
  }

  .number_time {
    margin: 40px 0 60px 0;
  }

  .number_time div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #707f9d;
    font-size: 25px;
  }

  .number_time p {
    width: 100%;
    height: 1px;
    background: #707f9d;
    margin-top: 8px;
  }

  .number_time p:last-child {
    opacity: 0.5;
    margin-top: 4px;
  }

  .division {
    position: relative;
    clear: both;
    font-weight: bold;
    font-size: 44px;
    color: #1d244e;
    margin: 35px 0;
  }

  .chart_box,
  .catalogue h3 {
    font-weight: 700;
    font-size: 50px;
    color: #1d244e;
  }

  .chart_box h3 {
    font-size: 50px;
    margin-bottom: 35px;
  }

  .catalogue h3 {
    margin-bottom: 15px;
    margin-top: 50px;
    line-height: 40px;
  }

  .chart_box,
  .catalogue h4 {
    font-weight: 700;
    font-size: 50px;
    color: #1d244e;
  }

  .chart_box h4 {
    font-size: 42px;
    margin-top: 35px;
    margin-bottom: 35px;
  }

  .catalogue h4 {
    margin-bottom: 15px;
    margin-top: 50px;
  }

  .chart_box,
  .catalogue h5 {
    font-weight: 700;
    font-size: 45px;
    color: #1d244e;
  }

  .catalogue h5 {
    margin-bottom: 15px;
    margin-top: 50px;
    line-height: 40px;
  }

  .chart_box h5 {
    font-size: 40px;
    margin-top: 35px;
    margin-bottom: 35px;
  }

  .chart_box h6 {
    font-weight: 700;
    font-size: 39px;
    color: #1d244e;
    line-height: 40px;
    margin-bottom: 15px;
    margin-top: 50px;
  }

  .chart_box p {
    font-weight: 540;
    font-size: 35px;
    text-indent: 2em;
    line-height: 70px;
    color: #272a3f;
  }

  .chart_box .echartsHeight {
    /* width: 80%; */
    /* height: calc(100vw / 1080 * 300); */
    height: 400px;
    /* height:30rem; */
    margin: 10px auto 0px;
  }

  .chart_box .chart_name {
    font-weight: 540 !important;
    text-align: center;
    font-size: 32px;
    color: #272a3f;
    clear: both;
    /* margin-bottom: 40px; */
    margin-top: 20px;
  }

  .chart_box .notes {
    margin: 35px 0;
    line-height: 50px;
    font-size: 30px;
    color: black;
  }

  .export {
    width: 88px;
    height: 32px;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
  }

  .center {
    text-align: center;
  }

  .divorced {
    margin-top: 40px;
  }

  .biaoge {
    /* height: 720px; */
    font-weight: 540 !important;
    width: 97%;
    margin: 0px auto 25px;
    /* font-size: 16px !important; */
    color: #272a3f !important;
  }

  .biaoge .twoTable {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .course {
    text-align: center;
    margin: 0px 10px;
  }

  .course tr {
    height: 45px;
    line-height: 45px;
    color: #707f9d;
    font-size: 22px;
  }

  .course tr:nth-child(2n) {
    background: rgba(11, 201, 212, 0.2);
    color: #566178;
  }

  .course tr:nth-child(2n-1) {
    background: rgba(73, 187, 233);

    color: #566178;
  }

  .course tr:first-child {
    background: rgb(88, 136, 248);
    color: #fff;
  }

  ::v-deep .el-progress-bar__innerText {
    color: #000;
    font-size: 25px;
  }

  .HomePage {
    position: relative;
    padding-left: 10%;
    padding-top: 18%;
  }

  .HomePage #image {
    width: 559px;
    height: 70px;
    background: url("../../../../public/pdf_year.png") no-repeat;
    background-size: 100% 100%;
  }

  #PdfTitle {
    padding: 20px 0px 20px 40px;
    position: relative;
  }

  #FristTitle {
    font-size: 65px;
    font-weight: 700;
    margin-bottom: 40px;
  }

  #SecondTitle {
    font-size: 65px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  #ThrendTitle {
    font-size: 50px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  #FourTitle {
    font-size: 50px;
    font-weight: 700;
    margin-bottom: 40px;
  }

  #foot {
    display: flex;
  }

  .HomePage .footBox {
    flex-direction: column;
    display: flex;
    align-items: center;
    font-size: 42px;
    margin-left: 4.5%;
  }

  .HomePage #foot p {
    margin: 20px 0px;
  }

  /* 目录级别 */
  .catalogue .title {
    text-align: center;
    margin-bottom: 4%;
    font-size: 40px;
  }

  .top {
    margin-top: 140px;
  }
</style>
<style lang="scss" scoped>
  .page-box {
    // padding: 7% 0;
    // height: 2740px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    // border: 1px solid red;
    .m-top150 {
      margin-top: 150px;
    }

    .m-top50 {
      margin-top: 50px;
    }

    .m-top100 {
      margin-top: 100px;
    }

    .biaoge {
      width: 95%;
      margin: 25px auto;

      .course {
        text-align: center;
        margin: 0px 10px;

        tr {
          height: 42px;
          color: #707f9d;
          font-size: 22px;

          &:nth-child(2n) {
            background: #fff;
            color: #566178;
          }

          &:nth-child(2n-1) {
            background: #7ed2ff;
            color: #566178;
          }
        }
      }
    }
  }

  .catalogue {
    position: relative;
    // padding: 10% 8%;

    .title {
      text-align: center;
      margin-bottom: 4%;
      font-size: 40px;
    }

    .Second_text {
      padding-left: 1.8em;
    }

    .Thred_text {
      padding-left: 7.69em;
    }

    h5 {
      display: flex;
      align-items: center;

      .dot {
        flex: 1;
        border-top: dotted #1d244e 7px;
        /* 可设置大小，查属性参数dotted可换其他样式 */
        margin: 0 10px;
        /* 用来控制文字与填充线的间隔大小 */
      }
    }
  }

  .flex-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    & > div {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  .right {
    float: right;
    margin-right: 20px;
    font-size: 32px;
  }
</style>
